export default __webpack_public_path__ + "d28dcb5ad3a5c658af689b52b51a752d.svg";